import * as Yup from "yup";
import { BaseOrderSchema } from "./BaseOrderSchema";

export const UpdateOrderSchema = BaseOrderSchema.shape({
    status: Yup.string(),
});
